import SessionService from "../../../../../../services/session/SessionService";
import { Weather } from "../weather/Weather";
import { Clock } from "../clock/Clock";
import { NavigateItems, NavigatorCenter, NavigatorLeft, NavigatorRight, NavigatorWrapper, ScreenTitle, ScreenTitleCn, ScreenTitleEn, NavigateItemSeparator, NavigateItemLeft, NavigateItemRight } from "./Navigator.styled";

interface NavigatorProps {
    selected?: string
}

let Navigator: React.FC<NavigatorProps> = (props)=> {
    let tenantNo = SessionService.getInstance().getCurrentUserProfile().tenantNo;
    let title = {
        cn: "云融互联系统",
        en: "Fusion Link System"
    };
    
    return (
        <NavigatorWrapper>
            <NavigatorLeft>
                <NavigateItems>
                    <NavigateItemLeft href="/#/big-screen/overview" className={props.selected=='OVERVIEW' ? "selected" : "" }>系统总览</NavigateItemLeft>
                    <NavigateItemLeft className={props.selected=='DEVICE_DETAILS' ? "selected" : ""} >设备详情</NavigateItemLeft>
                </NavigateItems>
            </NavigatorLeft>

            <NavigatorCenter>
                <ScreenTitle>
                    <ScreenTitleCn>{title.cn}</ScreenTitleCn>
                    <ScreenTitleEn>{title.en}</ScreenTitleEn>
                </ScreenTitle>
            </NavigatorCenter>

            <NavigatorRight>
                <NavigateItemRight href={SessionService.getInstance().getCurrentUserProfile().admin ? "/#/" : '#'}>管理控制台</NavigateItemRight>
                <Weather />
            </NavigatorRight>
        </NavigatorWrapper>
    )
};

export default Navigator;
